import { SITES } from '../models/widget-calculator.models';

// When site is accepted/handled, add it to accepted
export const ACCEPTED_SITES = [SITES.EFFY, SITES.CALCULEO, SITES.LPE, SITES.QE];

export const DEFAULT_SITE = SITES.EFFY;
